"use client"

import React, { HTMLAttributes, useEffect, useState } from 'react'

import styles from './styles.module.css'

interface IInPageNavigationTabProps extends HTMLAttributes<HTMLDivElement> {
  detectPosition?: boolean;
  sectionId?: string | number;
  navigateToId: string | number;
  text: string;
};

export const InPageNavigationTab: React.FC<IInPageNavigationTabProps> = ({ navigateToId, className, detectPosition, text, sectionId }) => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (sectionId !== undefined) {
      window.addEventListener('scroll', isInSection);
      return () => {
        window.removeEventListener('scroll', isInSection);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sectionId]);

  const isInSection = (e: Event) => {
    const section = document.getElementById(`section-${sectionId}`);
    const sectionPositions = section?.getBoundingClientRect();
    const sectionTop = (sectionPositions?.top || 0) - 110;
    const sectionHeight = sectionPositions?.height || 0
    if (section !== undefined && sectionTop < 48 && sectionTop > (sectionHeight * -1)) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  };

  const scrollTo = (sectionId: string | number) => {
    const section = document.getElementById(`section-${sectionId}`);
    const body = document.body;

    if (section) {
      window.scrollTo({ top: section.getBoundingClientRect().top - body.getBoundingClientRect().top - 120 });
    }
  };

  return (
    <button
      onClick={() => scrollTo(navigateToId)}
      className={detectPosition ? `
        ${styles['link']} flex flex-col whitespace-nowrap text-ellipsis w-fit text-gray-700 space-y-4 h-fit text-base
      hover:text-gray-900 ${isActive && '!text-gray-700 ' + styles['selected-link']} ${className}
      ` : className}
    >
      {text}
    </button>
  )
}